import {
  social_selling_repository,
} from '@/repositories';

const actions = {
  async getContactsForEntryPoints(__, input) {
    const {
      user_id,
      account_id,
    } = input;

    const {
      results,
    } = await social_selling_repository.getContactsForEntryPoints(user_id, account_id)
      .catch(() => {
        return {
          results: [],
        };
      });

    return results;
  },
  async getContactsForIceBreakers(__, input) {
    const {
      user_id,
      account_id,
    } = input;

    const {
      results,
    } = await social_selling_repository.getContactsForIceBreakers(user_id, account_id)
      .catch(() => {
        return {
          results: [],
        };
      });

    return results;
  },
};

export default {
  actions,
  namespaced: true,
};
